// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Portrait from "./routes/Portrait";
import Landscape from "./routes/Landscape";
import Superindo from "./routes/SuperIndo";
import Preview from "./routes/Preview";

function App() {
  return (
    <Router>
      <nav style={{ padding: "1rem", background: "#ddd" }}>
        <Link to="/portrait" style={{ marginRight: "1rem" }}>
          Portrait
        </Link>
        <Link to="/landscape" style={{ marginRight: "1rem" }}>
          Landscape
        </Link>
        <Link to="/superindo" style={{ marginRight: "1rem" }}>
          superindo
        </Link>
      </nav>
      <Routes>
        <Route path="/portrait" element={<Portrait />} />
        <Route path="/landscape" element={<Landscape />} />
        <Route path="/superindo" element={<Superindo />} />
        <Route path="/preview" element={<Preview />} />
      </Routes>
    </Router>
  );
}

export default App;
